// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as RR from "common/src/RR.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as TC from "common/src/components/TC.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as TcUtils from "../team-comps/TcUtils.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemName from "common/src/tft-static/ItemName.bs.js";
import * as TcTitlei from "../team-comps/TcTitlei.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as TbUtils14 from "../team-planner14/TbUtils14.bs.js";
import * as TbUtils46 from "../team-planner46/TbUtils46.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Tc2Portals from "./Tc2Portals.bs.js";
import * as Tc2WinCons from "./Tc2WinCons.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Tc2ItemsTab from "./Tc2ItemsTab.bs.js";
import * as Tc2OtherTab from "./Tc2OtherTab.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as Tc2Headliner from "./Tc2Headliner.bs.js";
import * as Tc2Other2Tab from "./Tc2Other2Tab.bs.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Tc2VariantsTab from "./Tc2VariantsTab.bs.js";
import * as Tc2AugmentsTab2 from "./Tc2AugmentsTab2.bs.js";
import * as Tc2HeadlinersTab from "./Tc2HeadlinersTab.bs.js";
import Tab from "@mui/material/Tab";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import Tabs from "@mui/material/Tabs";
import * as Tc2UnitDistribution from "./Tc2UnitDistribution.bs.js";
import * as TcLevelDistribution from "./TcLevelDistribution.bs.js";
import * as Tc2TraitDistribution from "./Tc2TraitDistribution.bs.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import * as TcItemDistributionChart from "../team-comps/TcItemDistributionChart.bs.js";
import ButtonBase from "@mui/material/ButtonBase";
import IconButton from "@mui/material/IconButton";
import Clear from "@mui/icons-material/Clear";
import Hexagon from "@mui/icons-material/Hexagon";

function calcSafeDelta(delta, count) {
  return T.calcSafeSynergy(2.5, undefined, delta, count);
}

function Tc2Expanded$ItemUnits(Props) {
  var itemId = Props.itemId;
  var unitIds = Props.unitIds;
  return React.createElement("div", {
              className: "relative pb-3"
            }, React.createElement(ItemTooltip.make, {
                  itemId: itemId,
                  children: React.createElement(ItemImage.make, {
                        itemId: itemId,
                        size: 46,
                        rounded: "rounded"
                      })
                }), React.createElement("div", {
                  className: "absolute left-[-4px] right-[-4px] bottom-[-6px] flex justify-center"
                }, Belt_Array.map(unitIds, (function (unitId) {
                        return React.createElement(UnitTooltip.make, {
                                    unit: unitId,
                                    children: React.createElement(UnitImage.make, {
                                          rounded: "",
                                          unitId: unitId,
                                          size: unitIds.length === 1 ? 28 : 26,
                                          borderSize: 1,
                                          key: unitId
                                        }),
                                    key: unitId
                                  });
                      }))));
}

var ItemUnits = {
  make: Tc2Expanded$ItemUnits
};

function Tc2Expanded$ItemsRow(Props) {
  var tier = Props.tier;
  return Belt_Array.mapWithIndex(tier, (function (idx, param) {
                var itemId = param[0];
                return React.createElement(Tc2Expanded$ItemUnits, {
                            itemId: itemId,
                            unitIds: param[1],
                            key: itemId
                          });
              }));
}

var ItemsRow = {
  make: Tc2Expanded$ItemsRow
};

function Tc2Expanded$ItemsInfo(Props) {
  var group = Props.group;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  var match = TcUtils.getItemTiers(group, set);
  var bItems = match[2];
  var aItems = match[1];
  var sItems = match[0];
  return React.createElement("div", undefined, React.createElement("h4", {
                  className: "text-xl pb-[10px] font-montserrat font-medium"
                }, t("Itemization")), sItems.length === 0 ? null : React.createElement("div", {
                    className: "flex items-center gap-3 pb-[28px] pr-1"
                  }, React.createElement("div", {
                        className: "text-[26px] pr-1 mt-[2px] font-merienda font-bold text-legendary"
                      }, "S"), React.createElement(Tc2Expanded$ItemsRow, {
                        tier: sItems
                      })), aItems.length === 0 ? null : React.createElement("div", {
                    className: "flex pb-[28px] items-center gap-3"
                  }, React.createElement("div", {
                        className: "text-[26px] pr-1 mt-[2px] font-merienda font-bold text-epic"
                      }, "A"), React.createElement(Tc2Expanded$ItemsRow, {
                        tier: aItems
                      })), bItems.length === 0 ? null : React.createElement("div", {
                    className: "flex items-center gap-3"
                  }, React.createElement("div", {
                        className: "text-[26px] pr-1 mt-[2px] font-merienda font-bold text-rare"
                      }, "B"), React.createElement(Tc2Expanded$ItemsRow, {
                        tier: Belt_Array.slice(bItems, 0, 5)
                      })));
}

var ItemsInfo = {
  make: Tc2Expanded$ItemsInfo
};

function Tc2Expanded$CompStats(Props) {
  var group = Props.group;
  var globalCount = Props.globalCount;
  var t = Translation.useT(/* Common */0);
  var pr = Global.f(group.count) / Global.f(globalCount) * 8;
  return React.createElement("div", {
              className: "font-montserrat w-[320px] grid gap-1 text-[16px] leading-[18px] text-center"
            }, React.createElement("div", {
                  className: "grid grid-cols-[auto,auto,auto,auto] gap-x-[14px] gap-y-[10px]"
                }, React.createElement("div", undefined, React.createElement("div", {
                          className: "text-white2 pb-1"
                        }, t("Play Rate")), React.createElement("div", {
                          className: "font-medium text-center text-[18px]"
                        }, pr < 0.01 ? pr.toFixed(3).slice(1, 99) : pr.toFixed(2))), React.createElement("div", undefined, React.createElement("div", {
                          className: "text-white2 pb-1"
                        }, t("Place")), React.createElement("div", {
                          className: "font-medium text-center text-[18px]"
                        }, Global.toFixed(undefined, group.place))), React.createElement("div", undefined, React.createElement("div", {
                          className: "text-white2 pb-1"
                        }, t("Top 4 %")), React.createElement("div", {
                          className: "font-medium text-center text-[18px]"
                        }, Global.formatPct(undefined, Global.f(group.top4) / Global.f(group.count)))), React.createElement("div", undefined, React.createElement("div", {
                          className: "text-white2 pb-1"
                        }, t("Win %")), React.createElement("div", {
                          className: "font-medium text-center text-[18px]"
                        }, Global.formatPct(undefined, Global.f(group.win) / Global.f(group.count))))));
}

var CompStats = {
  make: Tc2Expanded$CompStats
};

function Tc2Expanded$CompUnits(Props) {
  var exampleItems = Props.exampleItems;
  var filters = Props.filters;
  var group = Props.group;
  var prioStars = Props.prioStars;
  var otherStars = Props.otherStars;
  var emblem = Props.emblem;
  var aperture = ApertureCtx.useValue(undefined);
  Translation.useT(/* Common */0);
  var starUnits = group.starUnits;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        if (Belt_Option.isSome(emblem)) {
          return /* Spat */1;
        } else {
          return /* Base */0;
        }
      });
  switch (match[0]) {
    case /* Base */0 :
        group.nonSpatComps2.length === 0;
        break;
    case /* Spat */1 :
        group.spatComps2.length === 0;
        break;
    case /* Lv9 */2 :
        group.lvl9Comps.length === 0;
        break;
    
  }
  var t = Translation.useT(/* Common */0);
  var comps = Belt_Option.isNone(emblem) && group.nonSpatComps2.length !== 0 ? group.nonSpatComps2 : group.spatComps2;
  var comps$1 = Belt_Array.slice(Belt_SortArray.stableSortBy(comps, (function (c1, c2) {
              return -Caml_obj.caml_compare(c1.count, c2.count) | 0;
            })), 0, 5);
  var coreUnits = TC.extractCore(Belt_Array.map(comps$1, (function (c) {
              return c.units;
            })));
  var bestComp = TcUtils.getBestComp(group, emblem, filters, set, coreUnits);
  return React.createElement("div", {
              className: "flex flex-col items-start sm:flex-row gap-3 sm:gap-4"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "shrink-0 flex items-center pb-2 w-full"
                    }, React.createElement("div", {
                          className: "h-[1px] bg-white flex-1"
                        }), React.createElement("div", {
                          className: "px-[5px]"
                        }, t("Core")), React.createElement("div", {
                          className: "h-[1px] bg-white flex-1"
                        })), React.createElement("div", {
                      className: "flex items-center pb-2 h-[56px]"
                    }, React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(coreUnits, (function (idx, unitId) {
                                var starTooltip = Belt_Option.map(Belt_Option.flatMap(starUnits, (function (su) {
                                            return Js_dict.get(su, unitId);
                                          })), (function (__x) {
                                        return TcUtils.getStarTooltip(__x, unitId);
                                      }));
                                var tmp = {
                                  className: "mx-1",
                                  size: 44,
                                  unitId: unitId,
                                  goldenStars: prioStars.includes(unitId),
                                  items: Belt_Option.getWithDefault(Belt_MapString.get(exampleItems, unitId), []),
                                  unfilteredItems: true,
                                  key: String(idx)
                                };
                                var tmp$1 = prioStars.includes(unitId) || otherStars.includes(unitId) ? (
                                    Sd.unitTier(unitId) === 5 ? 2 : 3
                                  ) : undefined;
                                if (tmp$1 !== undefined) {
                                  tmp.starLevel = Caml_option.valFromOption(tmp$1);
                                }
                                if (starTooltip !== undefined) {
                                  tmp.starTooltip = Caml_option.valFromOption(starTooltip);
                                }
                                return React.createElement("a", {
                                            key: String(idx),
                                            href: Route.toString({
                                                  TAG: /* Stats */0,
                                                  _0: {
                                                    TAG: /* Unit */4,
                                                    unit: unitId,
                                                    starLevel: undefined,
                                                    aperture: aperture
                                                  }
                                                }),
                                            target: "_blank"
                                          }, React.createElement(UnitImageExtended.make, tmp));
                              }))))), React.createElement("div", undefined, React.createElement("div", {
                      className: "shrink-0 flex items-center pb-2 w-full"
                    }, React.createElement("div", {
                          className: "h-[1px] bg-white flex-1"
                        }), React.createElement("div", {
                          className: "px-[5px]"
                        }, t("Flex")), React.createElement("div", {
                          className: "h-[1px] bg-white flex-1"
                        })), React.createElement("div", {
                      className: "flex flex-row flex-wrap sm:flex-col gap-4"
                    }, RR.mapDef([bestComp], (function (comp) {
                            var isVisible = TcUtils.compFilterMatch(comp, filters, set);
                            var units = TC.removeCoreUnits(comp.units, coreUnits);
                            var tmp;
                            if (comp.extraTraits.length === 1) {
                              try {
                                var traitId = Belt_Array.getExn(comp.extraTraits, 0);
                                tmp = React.createElement(Tc2Headliner.make, {
                                      traitId: traitId
                                    });
                              }
                              catch (exn){
                                tmp = null;
                              }
                            } else {
                              tmp = null;
                            }
                            return React.createElement("div", {
                                        className: "flex items-center px-[6px]" + (
                                          isVisible ? "opacity-100" : "opacity-30"
                                        )
                                      }, React.createElement(React.Fragment, undefined, RR.mapDef(units, (function (unitId) {
                                                  var starTooltip = Belt_Option.map(Belt_Option.flatMap(starUnits, (function (su) {
                                                              return Js_dict.get(su, unitId);
                                                            })), (function (__x) {
                                                          return TcUtils.getStarTooltip(__x, unitId);
                                                        }));
                                                  var tmp = {
                                                    className: "mx-1",
                                                    size: 44,
                                                    unitId: unitId,
                                                    goldenStars: prioStars.includes(unitId),
                                                    items: Belt_Option.getWithDefault(Belt_MapString.get(exampleItems, unitId), []),
                                                    unfilteredItems: true
                                                  };
                                                  var tmp$1 = prioStars.includes(unitId) || otherStars.includes(unitId) ? (
                                                      Sd.unitTier(unitId) === 5 ? 2 : 3
                                                    ) : undefined;
                                                  if (tmp$1 !== undefined) {
                                                    tmp.starLevel = Caml_option.valFromOption(tmp$1);
                                                  }
                                                  if (starTooltip !== undefined) {
                                                    tmp.starTooltip = Caml_option.valFromOption(starTooltip);
                                                  }
                                                  return React.createElement("a", {
                                                              href: Route.toString({
                                                                    TAG: /* Stats */0,
                                                                    _0: {
                                                                      TAG: /* Unit */4,
                                                                      unit: unitId,
                                                                      starLevel: undefined,
                                                                      aperture: aperture
                                                                    }
                                                                  }),
                                                              target: "_blank"
                                                            }, React.createElement(UnitImageExtended.make, tmp));
                                                }))), Belt_Array.mapWithIndex(comp.spatItems, (function (idx, itemId) {
                                              var unitsMap = Belt_MutableMapString.make(undefined);
                                              Belt_Array.forEach(group.unitItems, (function (ui) {
                                                      if (ui.itemId !== itemId) {
                                                        return ;
                                                      }
                                                      var curr = Belt_MutableMapString.getWithDefault(unitsMap, ui.unitId, 0);
                                                      return Belt_MutableMapString.set(unitsMap, ui.unitId, curr + ui.count | 0);
                                                    }));
                                              var unitId = Belt_Option.map(Belt_Array.get(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitsMap), (function (param, param$1) {
                                                              return Caml.caml_int_compare(param$1[1], param[1]);
                                                            })), 0), (function (prim) {
                                                      return prim[0];
                                                    }));
                                              return React.createElement("div", {
                                                          key: String(idx),
                                                          className: "relative p-[2px] pb-[6px]"
                                                        }, React.createElement(ItemImage.make, {
                                                              itemId: itemId,
                                                              size: 38,
                                                              rounded: "rounded"
                                                            }), unitId !== undefined ? React.createElement(UnitImage.make, {
                                                                unitId: unitId,
                                                                size: 24,
                                                                className: "absolute bottom-[-4px] left-[9px]"
                                                              }) : null);
                                            })), tmp);
                          })))));
}

var CompUnits = {
  make: Tc2Expanded$CompUnits
};

function Tc2Expanded$TopPlayers(Props) {
  var group = Props.group;
  var t = Translation.useT(/* Common */0);
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "pt-8 pb-4 font-montserrat font-medium text-xl"
                }, t("Top Players")), React.createElement("div", {
                  className: "grid grid-cols-[1fr] sm:grid-cols-[1fr_1fr] md:grid-cols-[1fr_1fr_1fr] gap-3"
                }, Belt_Array.mapWithIndex(Belt_Array.slice(group.topPlayers, 0, 9), (function (idx, param) {
                        var playerName = param[1];
                        var region = param[0];
                        return React.createElement(Link.make, {
                                    className: "overflow-hidden",
                                    route: {
                                      TAG: /* Player */2,
                                      _0: {
                                        region: Region.fromApiName(region),
                                        playerName: playerName,
                                        tag: param[3],
                                        match: undefined
                                      }
                                    },
                                    children: React.createElement(ButtonBase, {
                                          classes: {
                                            root: "w-full md:max-w-[216px]"
                                          },
                                          children: React.createElement("div", {
                                                className: "relative flex items-center justify-between w-full p-3 rounded bg-bg2"
                                              }, React.createElement("div", {
                                                    className: "text-left leading-none truncate"
                                                  }, playerName), React.createElement("div", {
                                                    className: "text-xs pl-2 text-white2"
                                                  }, Region.toName3(Region.fromApiName(region)) + " "))
                                        }),
                                    key: region + playerName
                                  });
                      }))));
}

var make = React.memo(Tc2Expanded$TopPlayers);

var TopPlayers = {
  make: make
};

function Tc2Expanded$OverviewBotWrap(Props) {
  var group = Props.group;
  var opened = Props.opened;
  var match = React.useState(function () {
        return false;
      });
  var setVisible = match[1];
  React.useEffect((function () {
          if (opened) {
            Curry._1(setVisible, (function (param) {
                    return true;
                  }));
          }
          
        }), [opened]);
  if (match[0]) {
    return React.createElement(React.Fragment, undefined, React.createElement(Tc2WinCons.make, {
                    winCons: group.winCons,
                    group: group
                  }), React.createElement(make, {
                    group: group
                  }));
  } else {
    return React.createElement("div", {
                className: "h-[820px]"
              });
  }
}

var OverviewBotWrap = {
  make: Tc2Expanded$OverviewBotWrap
};

function Tc2Expanded$OverviewTab(Props) {
  var filters = Props.filters;
  var group = Props.group;
  var globalCount = Props.globalCount;
  var opened = Props.opened;
  var emblem = Props.emblem;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  TcUtils.getPriorityComponents2(group, set);
  var exampleItems = TcUtils.getExampleItems(group, emblem, set);
  var match = TcUtils.getStarUnits(group);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex flex-col"
                }, React.createElement(Tc2Expanded$CompUnits, {
                      exampleItems: exampleItems,
                      filters: filters,
                      group: group,
                      globalCount: globalCount,
                      prioStars: match[0],
                      otherStars: match[1],
                      emblem: emblem
                    }), React.createElement("div", {
                      className: "flex flex-col sm:flex-row gap-8 sm:justify-between pt-4"
                    }, React.createElement("div", {
                          className: "flex flex-col gap-8"
                        }, React.createElement("div", undefined, React.createElement("div", {
                                  className: "flex items-center gap-2 pb-2 sm:pb-4"
                                }, React.createElement("h4", {
                                      className: "block text-xl font-montserrat font-medium leading-[28px]"
                                    }, t("Stats")), React.createElement("div", {
                                      className: "text-base leading-[24px] pt-[2px]"
                                    }, " (" + T.humanReadableCount(group.count) + " " + t("Games") + ")")), React.createElement(Tc2Expanded$CompStats, {
                                  group: group,
                                  globalCount: globalCount
                                })), React.createElement(Tc2Expanded$ItemsInfo, {
                              group: group
                            })), React.createElement("div", {
                          className: "flex flex-col gap-8"
                        }, React.createElement("div", undefined, React.createElement("div", {
                                  className: "text-xl font-medium font-montserrat"
                                }, t("Level Distribution")), React.createElement(TcLevelDistribution.make, {
                                  group: group
                                })), React.createElement("div", undefined, React.createElement("div", {
                                  className: "text-xl font-medium font-montserrat"
                                }, t("Top Item Users")), React.createElement(TcItemDistributionChart.make, {
                                  carryUnits: group.carryUnits
                                }))))), React.createElement(Tc2Expanded$OverviewBotWrap, {
                  group: group,
                  opened: opened
                }));
}

var make$1 = React.memo(Tc2Expanded$OverviewTab);

var OverviewTab = {
  make: make$1
};

function Tc2Expanded$Header(Props) {
  var group = Props.group;
  var onClose = Props.onClose;
  var tab = Props.tab;
  var setTab = Props.setTab;
  var emblem = Props.emblem;
  var t = Translation.useT(/* Common */0);
  ScreenAtom.use(undefined);
  var set = TftSet.use(undefined);
  var tmp;
  if (emblem !== undefined) {
    var itemId = emblem[0];
    tmp = React.createElement(Tooltip.make, {
          title: React.createElement("div", undefined, "This team composition requires ", React.createElement(ItemName.make, {
                    itemId: itemId
                  })),
          children: React.createElement(ItemImage.make, {
                itemId: itemId,
                size: 24,
                rounded: "rounded"
              })
        });
  } else {
    tmp = null;
  }
  var comps = group.nonSpatComps.length === 0 ? group.spatComps : group.nonSpatComps;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex justify-between items-center pb-2"
                }, React.createElement("div", {
                      className: "flex items-center gap-1"
                    }, tmp, React.createElement(TcTitlei.make, {
                          group: group
                        })), React.createElement("div", {
                      className: "flex items-center"
                    }, React.createElement("div", {
                          className: "pr-1"
                        }, React.createElement(Link.make, {
                              target: "_blank",
                              route: set === 140 ? ({
                                    TAG: /* TeamPlanner */3,
                                    _0: TbUtils14.generateBoard(Belt_Array.getExn(comps, 0).units, undefined)
                                  }) : ({
                                    TAG: /* TeamPlanner */3,
                                    _0: TbUtils46.generateBoard(Belt_Array.getExn(comps, 0).units, undefined)
                                  }),
                              children: React.createElement(Tooltip.make, {
                                    title: "Open in Team Builder",
                                    children: React.createElement(IconButton, {
                                          color: "primary",
                                          onClick: (function (param) {
                                              
                                            }),
                                          size: "small",
                                          children: React.createElement(Hexagon, {
                                                fontSize: "small"
                                              })
                                        })
                                  })
                            })), React.createElement(IconButton, {
                          onClick: (function (param) {
                              return Curry._1(onClose, undefined);
                            }),
                          size: "small",
                          children: React.createElement(Clear, {})
                        }))), React.createElement("div", {
                  className: "pb-4 flex justify-right max-w-[90vw] mx-[-16px]"
                }, React.createElement(Tabs, {
                      variant: "scrollable",
                      children: null,
                      value: tab,
                      onChange: (function (param, t) {
                          return Curry._1(setTab, (function (param) {
                                        return t;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: t("Overview"),
                          value: /* Overview */0
                        }), React.createElement(Tab, {
                          label: t("Units"),
                          value: /* Units */1
                        }), React.createElement(Tab, {
                          label: t("Items"),
                          value: /* Items */7
                        }), React.createElement(Tab, {
                          label: t("Variants"),
                          value: /* Variants */8
                        }), React.createElement(Tab, {
                          label: t("Traits"),
                          value: /* Traits */2
                        }), React.createElement(Tab, {
                          label: t("Other"),
                          value: /* Other */4
                        }))));
}

var Header = {
  make: Tc2Expanded$Header
};

function Tc2Expanded(Props) {
  var filters = Props.filters;
  var group = Props.group;
  var globalCount = Props.globalCount;
  var onClose = Props.onClose;
  var opened = Props.opened;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return /* Overview */0;
      });
  var tab = match[0];
  (Global.f(group.win) / Global.f(group.count) - Global.f(group.top4) / Global.f(group.count) / 4) * 40;
  var emblem = React.useMemo((function () {
          return TcUtils.getEmblem(group, set);
        }), [group]);
  var tmp;
  switch (tab) {
    case /* Overview */0 :
        tmp = React.createElement(make$1, {
              filters: filters,
              group: group,
              globalCount: globalCount,
              opened: opened,
              emblem: emblem
            });
        break;
    case /* Units */1 :
        tmp = React.createElement("div", {
              className: "flex justify-around"
            }, React.createElement(Tc2UnitDistribution.make, {
                  units: group.units,
                  groupCount: group.count,
                  unitItemCounts: group.unitItemCounts
                }));
        break;
    case /* Traits */2 :
        tmp = React.createElement("div", undefined, React.createElement(Tc2TraitDistribution.make, {
                  traits: group.traits,
                  traitTeams: group.traitTeams,
                  groupCount: group.count
                }));
        break;
    case /* Augments */3 :
        tmp = React.createElement("div", undefined, React.createElement(Tc2AugmentsTab2.make, {
                  augmentSingles: group.augmentSingles,
                  aug1s: group.aug1s,
                  aug2s: group.aug2s,
                  aug3s: group.aug3s,
                  groupCount: group.count
                }));
        break;
    case /* Other */4 :
        tmp = React.createElement(Tc2OtherTab.make, {
              group: group,
              globalCount: globalCount
            });
        break;
    case /* Other2 */5 :
        tmp = React.createElement(Tc2Other2Tab.make, {
              group: group,
              globalCount: globalCount
            });
        break;
    case /* Portals */6 :
        tmp = React.createElement(Tc2Portals.make, {
              group: group,
              globalCount: globalCount
            });
        break;
    case /* Items */7 :
        tmp = React.createElement(Tc2ItemsTab.make, {
              group: group
            });
        break;
    case /* Variants */8 :
        tmp = React.createElement(Tc2VariantsTab.make, {
              group: group
            });
        break;
    case /* Headliners */9 :
        tmp = React.createElement(Tc2HeadlinersTab.make, {
              group: group
            });
        break;
    
  }
  return React.createElement("div", {
              className: "text-white1"
            }, React.createElement(Tc2Expanded$Header, {
                  group: group,
                  onClose: onClose,
                  tab: tab,
                  setTab: match[1],
                  emblem: emblem
                }), tmp);
}

var make$2 = React.memo(Tc2Expanded);

export {
  calcSafeDelta ,
  ItemUnits ,
  ItemsRow ,
  ItemsInfo ,
  CompStats ,
  CompUnits ,
  TopPlayers ,
  OverviewBotWrap ,
  OverviewTab ,
  Header ,
  make$2 as make,
  
}
/* make Not a pure module */
